import classes from './review-list.module.scss';
import Conditional from '@next-app/components/Conditional';

const ReviewStars = ({
  productId,
  rating,
  showNumber,
  useAltWidth = false,
  useColStyles = false,
  useReviewSectionStyles = false,
}: {
  productId?: string;
  rating: number;
  showNumber?: boolean;
  useAltWidth?: boolean;
  useColStyles?: boolean;
  useReviewSectionStyles?: boolean;
}) => {
  const handleClick = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.stopPropagation();
    sessionStorage.setItem('reactReferrerUrl', window.location.href);
    window.location.href = `/product-review/${productId}`;
  };

  return (
    <>
      <Conditional if={showNumber || false}>
        <span
          className={`${classes.rating}${useColStyles ? ` ms-auto ${classes.col}` : ''}`}
        >
          {parseFloat(rating.toString()).toFixed(1)}
        </span>
      </Conditional>
      <span
        className={`${classes['stars']} ${useReviewSectionStyles ? ` ${classes['review-section']}` : ''} ${showNumber ? ` float-none${useColStyles ? ` ${classes.col}` : ''}` : ` ${useColStyles && rating === 0 ? `ms-auto ${classes['col-no-reviews']}` : ''}`}`}
      >
        <span
          className={classes['gold']}
          style={{ width: `${rating * (!useAltWidth ? 20 : 26)}px` }}
        ></span>
      </span>
      <Conditional if={useColStyles && rating === 0}>
        <span
          onClick={handleClick}
          className={`${classes['btn-review']} ${classes.col}`}
        >
          Be the first!
        </span>
      </Conditional>
    </>
  );
};

export default ReviewStars;
